import { render, staticRenderFns } from "./UpdatePostcode.vue?vue&type=template&id=11104cde&"
import script from "./UpdatePostcode.vue?vue&type=script&lang=js&"
export * from "./UpdatePostcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports